import { render, staticRenderFns } from "./CreateNewInvoice.vue?vue&type=template&id=5e0410a2&scoped=true"
import script from "./CreateNewInvoice.vue?vue&type=script&lang=js"
export * from "./CreateNewInvoice.vue?vue&type=script&lang=js"
import style0 from "./CreateNewInvoice.vue?vue&type=style&index=0&id=5e0410a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0410a2",
  null
  
)

export default component.exports